import type { FunctionComponent } from 'react';
import { useClient } from '../api';
import { TopicScreenActiveSession } from '../components/topic/active-session/TopicScreenActiveSession';
import { TopicScreenPresentation } from '../components/topic/active-session/TopicScreenPresentation';
import { TopicScreenNoActiveSession } from '../components/topic/no-active-session/TopicScreenNoActiveSession';
import { NeedContentProvider } from '../contexts/need-content-context';
import { useYwuApp } from '../contexts/ywu-app-context';

export const TopicScreen: FunctionComponent = () => {
    const { isPresentationMode } = useYwuApp();
    const { data: client } = useClient();

    return (
        <NeedContentProvider>
            {!client ? <TopicScreenNoActiveSession /> : isPresentationMode ? <TopicScreenPresentation /> : <TopicScreenActiveSession />}
        </NeedContentProvider>
    );
};
